<template>
    <div class="kt-portlet">
        <div class="kt-portlet__body" style="color: black; background-color: #fff">
            <h6>{{ $t('dashboard.label.total_balance') }}</h6>
            <div class="text-center">
                <h2 class="fix-margin">
                    {{ balance.total_balance }}
                    <span style="font-size: 1.5rem">
                        {{' ' + $t('currency.rial')}}
                    </span>
                </h2>
            </div>
            <div class="position-absolute" style="left:25px;top:18px;cursor: pointer; color: #0f9af0" data-toggle="dropdown">
                <i class="fa fa-info-circle" aria-hidden="true" style="font-size: 1.6em;"></i>
            </div>
            <ul class="dropdown-menu">
                <div class="dropdown-header">{{ $t('dashboard.label.pardakhtyari_settling_balance') }}</div>
                <li class="text-center">
                    {{ balance.pardakhtyari_settling }}
                    <span style="font-size: 1.2rem">
                        {{' ' + $t('currency.rial')}}
                    </span>
                </li>
                <li class="divider"></li>
                <div class="dropdown-header">{{ $t('dashboard.label.other_settling_balance') }}</div>
                <li class="text-center">
                    {{ balance.other_settling }}
                    <span style="font-size: 1.2rem">
                        {{' ' + $t('currency.rial')}}
                    </span>
                </li>
                <li class="divider"></li>
                <div class="dropdown-header">{{ $t('dashboard.label.marketing_settling_balance') }}</div>
                <li class="text-center">
                    {{balance.marketing_settling}}
                    <span style="font-size: 1.2rem">
                        {{' ' + $t('currency.rial')}}
                    </span>
                </li>
            </ul>
            <div class="line-divider mt-4 mb-3"></div>
            <div class="row">
                <div class="col-md-4 col-lg-4 col-sm-4 border-right">
                    <div class="mb-3" style="font-size: 0.82rem">
                        {{ $t('dashboard.label.pardakhtyari_balance') }}
                    </div>
                    <div class="text-center">
                        <h5 class="fix-margin">
                            {{ balance.pardakhtyari_balance }}
                            <span style="font-size: 1.2rem">
                                {{' ' + $t('currency.rial')}}
                            </span>
                        </h5>
                    </div>
                </div>
                <div class="col-md-4 col-lg-4 col-sm-4 border-right">
                    <div class="mb-3" style="font-size: 0.82rem">
                        {{ $t('dashboard.label.other_balance') }}
                    </div>
                    <div class="text-center">
                        <h5 class="fix-margin">
                            {{ balance.other_balance }}
                            <span style="font-size: 1.2rem">
                                {{' ' + $t('currency.rial')}}
                            </span>
                        </h5>
                    </div>
                </div>
                <div class="col-md-4 col-lg-4 col-sm-4 ">
                    <div class="mb-3" style="font-size: 0.82rem">
                        {{ $t('marketing.dashboard.marketing_balance') }}
                    </div>
                    <div class="text-center">
                        <h5 class="fix-margin">
                            {{ balance.marketing_balance }}
                            <span style="font-size: 1.2rem">
                                {{' ' + $t('currency.rial')}}
                            </span>
                        </h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "balance",

        props: {
            balance: {
                default() {
                    return {}
                }
            },
        },
    }
</script>

<style>
.line-divider {
    height: 1px;
    background-color: #777;
}
</style>